import React from 'react';
import { useLanguage } from '../../../context/language/LanguageContext';
import { primaryData } from '../../../utils/primaryData';
import './Primary.css';
import edu2 from '../../../assets/images/education/edu2.jpg';

const Primary = () => {
    const { language } = useLanguage();
    const data = primaryData[language];

    return (
        <div className="primary-page">
            <div className="primary-hero">
                <div className="hero-overlayprimary"></div>
                <div className="hero-contentprimary">
                    <div className="hero-textprimary">
                        <h1>{data.title}</h1>
                        <div className="title-dividerprimary">
                            <span></span>
                            <i className="fas fa-dharmachakra"></i>
                            <span></span>
                        </div>
                        <p className="hero-subtitleprimary">{data.subtitle}</p>
                    </div>
                    <div className="hero-cardsprimary">
                        <div className="stat-cardprimary">
                            <i className="fas fa-book-reader"></i>
                            <h3>{language === 'my' ? 'သင်ရိုးဘာသာ' : 'Subjects'}</h3>
                            <p>4</p>
                        </div>
                        <div className="stat-cardprimary">
                            <i className="fas fa-question-circle"></i>
                            <h3>{language === 'my' ? 'မေးခွန်းအရေအတွက်' : 'Questions per Subject'}</h3>
                            <p>8</p>
                        </div>
                        <div className="stat-cardprimary">
                            <i className="fas fa-award"></i>
                            <h3>{language === 'my' ? 'အောင်မှတ်' : 'Pass Mark'}</h3>
                            <p>32</p>
                        </div>
                        <div className="stat-cardprimary">
                            <i className="fas fa-star"></i>
                            <h3>{language === 'my' ? 'ဂုဏ်ထူးမှတ်' : 'Distinction Mark'}</h3>
                            <p>65</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="primary-container">
                <div className="subjects-section">
                    <h2>{language === 'my' ? 'သင်ရိုးညွှန်းတမ်း' : 'Curriculum'}</h2>
                    <div className="exam-note">
                        <div className="note-icon">
                            <i className="fas fa-graduation-cap"></i>
                        </div>
                        <p>{data.note.content}</p>
                    </div>

                    <div className="subjects-grid">
                        {data.subjects.map((subject, index) => (
                            <div key={index} className="subject-card">
                                <div className="subject-number">{(index + 1).toString().padStart(2, '0')}</div>
                                <h3>{subject.title}</h3>
                                {subject.subtopics && (
                                    <ul className="subject-subitems">
                                        {subject.subtopics.map((item, idx) => (
                                            <li key={idx}>{item}</li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                <div className="primary-conclusion-card">
                    <div className="conclusion-content">
                        {data.description.map((paragraph, index) => (
                            <p key={index}>{paragraph}</p>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Primary;